const emptyGuid = "00000000-0000-0000-0000-000000000000";

export const getStoredEmployeeId = () => {
  const employeeId = localStorage.getItem("employeeId");
  if (!employeeId || employeeId === emptyGuid) {
    throw new Error(
      "Employee id was not found. Please visit your HR profile page or re-login.",
    );
  }

  return employeeId;
};
